import DataVActiveRingChart from './active-ring-chart';
export default DataVActiveRingChart;
